import { inject, Injectable } from "@angular/core";
import { catchError, map, of, switchMap, tap } from "rxjs";
import * as BulkOrderActions from '../actions/bulk-order.action';
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ApiService } from '../../../../SGRE-shared/services/api.service';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { BulKOrderEffectsService } from './bulk-order.effects.service';
import { bulkOrderResponse } from "../bulk-order.state";
import * as StorageActions from '../../../../SGRE-shared/store/shared-store/actions/browser-storage.action';
import { BulkOrderSubmitResponse } from "../../models/bulk-order.model";
import { LoggerService, tryNormalizeHttpError } from "@spartacus/core";

@Injectable()
export class BulkOrderEffects {

    protected logger = inject(LoggerService);

    constructor(
        private actions: Actions,
        private apiService: ApiService,
        private globalService: GlobalService,
        private effectsService: BulKOrderEffectsService,
    ) { }

    FetchBulkOrder = createEffect(() =>
        this.actions.pipe(
            ofType(BulkOrderActions.checkProducts),
            switchMap((action) => this.apiService.checkbulkOrder(action.queryText, action.products)),
            map((data: bulkOrderResponse) => {
                // Extract error products

                let updateData = this.effectsService.getTableData(data.body);
                this.globalService.loadingSubject.next(false);

                // Dispatch multiple actions
                return [
                    BulkOrderActions.checkProductsSuccess({ checkProduct: updateData }),

                ];
            }),
            // Flatten the array of actions
            switchMap((actions) => actions),
            catchError((error) => of(BulkOrderActions.checkProductsFail({ payload: tryNormalizeHttpError(error, this.logger) })))
        )
    )
    SubmitBulkOrderProduct = createEffect(() =>
        this.actions.pipe(
            ofType(BulkOrderActions.submitBulkOrder),
            switchMap((action) => {
                const updateData = this.effectsService.updateTableFoundData(action.reqBody);
                return this.apiService.postBulkOrder(updateData, action.cartName)
                    .pipe(
                        tap((data: BulkOrderSubmitResponse) => {
                            this.globalService.loadCartsListByLegalEntity();
                        }),
                        switchMap((data: BulkOrderSubmitResponse) => [
                            BulkOrderActions.submitBulkOrderSuccess({ submitProducts: { submitProduct: data.body } }),
                            StorageActions.setCartId({ cartId: data.body }),
                        ]),
                        catchError((error) => {
                            this.globalService.loadingSubject.next(false);
                            return of(BulkOrderActions.submitBulkOrderFail({ payload: tryNormalizeHttpError(error, this.logger) }));
                        })
                    );
            }),

        )
    );
}
